// Test invitations accept South African local format; other countries use international format.
export function normaliseTestNumber(value) {
  let number = value
    .trim()
    .replace(/[ ()-]/g, '')
    .replace(/^\+/, '')
    .replace(/^00/, '');
  if (/^0[1-9]\d{8}$/.test(number)) number = `27${number.slice(1)}`;
  if (!/^[1-9]\d{6,14}$/.test(number)) return null;
  if (number.startsWith('27') && !/^27[1-9]\d{8}$/.test(number)) return null;
  return number;
}
